import { IBEError } from '@common/interfaces/be-error.interface';
import { UseQueryOptions } from '@common/interfaces/query-options.interface';
import { TIntegrationV1UtilsReferralCouponSharingGetError, utilApiRequest } from '@src/api/util-generated-api';
import { useQuery, UseQueryResult } from 'react-query';

export interface IGetInviteQueryParams {
    title: string;
    description: string;
    redirect_url: string;
}
const NAME = 'util';
const useGetInviteUrl = (
    query: IGetInviteQueryParams | undefined,
    queryOptions?: UseQueryOptions,
): UseQueryResult<void, IBEError<TIntegrationV1UtilsReferralCouponSharingGetError>> => {
    return useQuery<void, IBEError<TIntegrationV1UtilsReferralCouponSharingGetError>>(
        `${NAME}-invite-url`,
        () => {
            return utilApiRequest.integrationV1UtilsReferralCouponSharingGet(query).then((r) => r.data);
        },
        queryOptions,
    );
};

export interface IAppSettings {
    marketingAddonsMinimumPriceForFreeDelivery: number;
}
const useGetAppSettings = (
    queryOptions?: UseQueryOptions,
): UseQueryResult<IAppSettings, IBEError<TIntegrationV1UtilsReferralCouponSharingGetError>> => {
    return useQuery<IAppSettings, IBEError<TIntegrationV1UtilsReferralCouponSharingGetError>>(
        `${NAME}-global-settings`,
        () => {
            return Promise.resolve({
                marketingAddonsMinimumPriceForFreeDelivery: 145,
            });
        },
        queryOptions,
    );
};
export const util = {
    useGetAppSettings,
    useGetInviteUrl,
};
